<template>
  <div class="new-user-form__advanced-details-form">
    <div
      class="advanced-details-form__header cursor-pointer"
      @click="showAdvancedDetailsForm"
    >
      <div>
        <p class="text-secondary-orange font-semibold">Advanced Details</p>
      </div>
      <div class="line-wrapper">
        <hr />
      </div>
      <div :class="{ open: isAdvancedForm }" class="dropdown-icon">
        <svg
          width="14"
          height="7"
          viewBox="0 0 10 7"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M1 1.03467L5 5.03467L9 1.03467"
            stroke="#F57A4D"
            stroke-width="3"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>
    <div
      :class="{ show: isAdvancedForm }"
      class="advanced-details-form__main"
      ref="advancedDetails"
    >
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-4 col-lg-4 col-12">
            <label class="label">Designation</label>
            <el-select v-model="user.designationId" placeholder="Select">
              <el-option
                v-for="designation in designations"
                :key="designation.id"
                :label="designation.name"
                :value="designation.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label class="label">Function</label>
            <!-- <input type="text" class="input" /> -->
            <el-select v-model="user.functionId" placeholder="Select">
              <el-option
                v-for="selectedFunction in functions"
                :key="selectedFunction.id"
                :label="selectedFunction.name"
                :value="selectedFunction.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label class="label">Job Level</label>
            <!-- <input type="text" class="input" /> -->
            <el-select v-model="user.levelId" placeholder="Select">
              <el-option
                v-for="level in jobLevels"
                :key="level.id"
                :label="level.name"
                :value="level.id"
              >
              </el-option>
            </el-select>
          </div>
          <div class="col-md-4 col-lg-4 col-12">
            <label class="label">Reporting To</label>
            <!-- <input type="text" class="input" /> -->
            <el-select v-model="user.reportingTo" placeholder="Select">
              <el-option
                v-for="person in people"
                :key="person.id"
                :label="
                  person.id ? `${person.firstname} ${person.lastname}` : 'Nil'
                "
                :value="person.id"
              >
              </el-option>
            </el-select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isAdvancedForm: false,
      functions: [{ name: "Nil", id: null }],
      designations: [{ name: "Nil", id: null }],
      jobLevels: [{ name: "Nil", id: null }],
      people: [{ name: "Nil", id: null }],
      user: {
        designationId: "",
        functionId: "",
        levelId: "",
        reportingTo: "",
      },
    };
  },
  mounted() {
    this.fetchAllRequiredData();
  },
  methods: {
    showAdvancedDetailsForm() {
      let content = this.$refs.advancedDetails;
      if (content.style.maxHeight) {
        content.style.maxHeight = null;
        content.style.marginBottom = null;
      } else {
        content.style.maxHeight = content.scrollHeight + 6 + "px";
        content.style.marginBottom = "1rem";
      }
      this.isAdvancedForm = !this.isAdvancedForm;
    },
    // async createPerson() {
    //   this.creatingPerson = true;
    //   try {
    //     let response = await this.$_createPerson(this.user);
    //     console.log(response);
    //     this.generateToast("User successfully created!", "success");
    //     this.resetInputFields();
    //     this.fetchAllRequiredData();
    //     this.creatingPerson = false;
    //   } catch (error) {
    //     this.handleError(error);
    //     this.creatingPerson = false;
    //   }
    // },
    async getAllPeople() {
      try {
        let response = await this.$_getAllPeople();
        console.log(response);
        let people = response.data.findPeople;
        this.people = this.people.concat(people);
      } catch (error) {
        this.handleError();
      }
    },
    async getFunctions() {
      try {
        let response = await this.$_getAllFunctions();
        console.log(response);
        let functions = response.data.functions;
        this.functions = this.functions.concat(functions);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getDesignations() {
      try {
        let response = await this.$_getAllDesignations();
        console.log(response);
        let designations = response.data.designations;
        this.designations = this.designations.concat(designations);
      } catch (error) {
        this.handleError(error);
      }
    },
    async getJobLevels() {
      try {
        let response = await this.$_getJobLevels();
        console.log(response);
        let jobLevels = response.data.levels;
        this.jobLevels = this.jobLevels.concat(jobLevels);
      } catch (error) {
        this.handleError(error);
      }
    },
    fetchAllRequiredData() {
      this.getFunctions();
      this.getDesignations();
      this.getJobLevels();
      this.getAllPeople();
    },
  },
};
</script>

<style scoped>
.advanced-details-form__header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2rem 0;
}
.label {
  font-size: 0.9rem;
}
.input-field {
  display: block;
  width: 100%;
  height: 2.75rem;
  margin-bottom: 0.5rem;
  background: #fafafd;
  border: 0.5px solid #c5d1e6;
  box-sizing: border-box;
  border-radius: 4px;
}
hr {
  display: inline-block;
}
.button-wrapper {
  padding: 2rem 15px;
}
.advanced-details-form__main {
  max-height: 0;
  overflow: hidden;
  transition: all ease 0.5s;
}
.advanced-details-form__main.show {
  height: auto;
}
.dropdown-icon {
  transition: all ease 0.5s;
}
.dropdown-icon.open {
  transform: rotate(180deg);
}
</style>
